import styled from "styled-components/macro";
import tw from "twin.macro";
import { media } from "../../../styles/global-style";
import { ButtonUtils, ImageBoxUtils, RowUtils } from "../../utils/styles/Utils";

export const Section = styled.section<{ navOpen: boolean }>`
  ${tw`flex items-center py-32 px-0`};

  ${RowUtils} {
    ${tw`items-center`};
  }
  ${({ navOpen }) => navOpen && "animation: fadeOut 0.5s ease-in-out forwards;"}
`;

export const Content = styled.div`
  ${tw` w-1/2 p-4 `};

  ${media.desktop} {
    ${tw`w-full text-center order-2`}

    ${ButtonUtils} {
      margin: 0 7px 15px;
    }
  }
`;

export const Welcome = styled.p`
  ${tw`text-lg font-light`};
`;

export const Name = styled.h1`
  ${tw`text-4xl capitalize my-3`};

  ${media.phone} {
    ${tw`text-3xl`}
  }
`;

export const Role = styled.h2`
  ${tw`text-xl capitalize font-light mt-0 mr-0 mb-8 `};

  ${media.phone} {
    ${tw`text-lg`}
  }
`;

export const Image = styled.div`
  ${tw` w-1/2 p-4`};

  ${ImageBoxUtils} {
    ${tw`bg-white25 border-solid border-8 border-white25 rounded-half w-full m-auto`};
    max-width: 360px;

    ${media.desktop} {
      max-width: 300px;
    }
  }

  ${media.desktop} {
    ${tw`w-full order-1`}
  }
`;

export const Photo = styled.img`
  ${tw`w-full rounded-half`};
`;
